document.addEventListener('DOMContentLoaded', () => {
    // 1. Mobile Drawer Elements
    const menuToggleBtn = document.getElementById('menuToggleBtn');
    const drawerCloseBtn = document.getElementById('drawerCloseBtn');
    const mobileDrawer = document.getElementById('mobileDrawer');
    const drawerOverlay = document.getElementById('drawerOverlay');

    function openDrawer() {
        mobileDrawer.classList.add('active');
        drawerOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
        mobileDrawer.classList.remove('active');
        drawerOverlay.classList.remove('active');
        document.body.style.overflow = '';
    }

    if (menuToggleBtn) menuToggleBtn.addEventListener('click', openDrawer);
    if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeDrawer);
    if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

    // Close drawer on link click
    const drawerLinks = document.querySelectorAll('.drawer-link');
    drawerLinks.forEach(link => {
        link.addEventListener('click', closeDrawer);
    });

    // 2. Mobile Search Bar Toggle & Live Predictive Search
    const mobileSearchTrigger = document.getElementById('mobileSearchTrigger');
    const searchSection = document.getElementById('searchSection');
    const clearSearchBtn = document.getElementById('clearSearchBtn');
    const searchInput = document.querySelector('.search-input');
    const searchForm = document.getElementById('searchForm');
    const predictiveDropdown = document.getElementById('predictiveSearchDropdown');

    let debounceTimer = null;

    function closePredictiveSearch() {
        if (predictiveDropdown) {
            predictiveDropdown.classList.remove('active');
            predictiveDropdown.setAttribute('aria-expanded', 'false');
            predictiveDropdown.innerHTML = '';
        }
    }

    function escapeHtml(str) {
        return String(str || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    async function fetchPredictiveSearch(query) {
        if (!predictiveDropdown) return;
        const cleanQuery = query.trim();
        if (cleanQuery.length < 2) {
            closePredictiveSearch();
            return;
        }

        predictiveDropdown.classList.add('active');
        predictiveDropdown.setAttribute('aria-expanded', 'true');
        predictiveDropdown.innerHTML = '<div class="predictive-search-loading"><span class="spinner"></span> جاري البحث...</div>';

        try {
            const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(cleanQuery)}&resources[type]=product&resources[limit]=6`);
            if (!response.ok) throw new Error('Search failed');
            const data = await response.json();
            const products = data.resources?.results?.products || [];

            if (products.length === 0) {
                predictiveDropdown.innerHTML = `
                    <div class="predictive-no-results">
                        <p>لا توجد نتائج مطابقة لـ "<strong>${escapeHtml(cleanQuery)}</strong>"</p>
                        <span class="predictive-hint">جرب البحث عن طراز مثل: WP30, K15, RT2, تابلت</span>
                    </div>
                `;
                return;
            }

            let html = '<ul class="predictive-search-list">';
            products.forEach(product => {
                const rawP = parseFloat(product.price);
                const priceFormatted = !isNaN(rawP) ? (Math.round(rawP) + ' $') : (product.price ? product.price.replace(/\.00/g, '') : '');
                const imgUrl = product.featured_image?.url || product.image || '';
                html += `
                    <li class="predictive-item">
                        <a href="${product.url}" class="predictive-item-link">
                            ${imgUrl ? `<img src="${imgUrl}" alt="${escapeHtml(product.title)}" class="predictive-item-img" width="50" height="50" loading="lazy">` : '<div class="predictive-item-placeholder"></div>'}
                            <div class="predictive-item-info">
                                <span class="predictive-item-title">${escapeHtml(product.title)}</span>
                                ${priceFormatted ? `<span class="predictive-item-price">${priceFormatted}</span>` : ''}
                            </div>
                        </a>
                    </li>
                `;
            });
            html += '</ul>';
            html += `
                <a href="/search?q=${encodeURIComponent(cleanQuery)}" class="predictive-view-all">
                    عرض جميع النتائج (${products.length}+) &larr;
                </a>
            `;
            predictiveDropdown.innerHTML = html;
        } catch (err) {
            console.error('Predictive search error:', err);
            predictiveDropdown.innerHTML = `
                <div class="predictive-no-results">
                    <a href="/search?q=${encodeURIComponent(cleanQuery)}" class="predictive-view-all">
                        عرض جميع نتائج البحث لـ "${escapeHtml(cleanQuery)}" &larr;
                    </a>
                </div>
            `;
        }
    }

    if (searchInput) {
        searchInput.addEventListener('input', (e) => {
            clearTimeout(debounceTimer);
            const val = e.target.value;
            debounceTimer = setTimeout(() => fetchPredictiveSearch(val), 250);
        });

        searchInput.addEventListener('focus', (e) => {
            if (e.target.value.trim().length >= 2) {
                fetchPredictiveSearch(e.target.value);
            }
        });
    }

    if (searchForm) {
        searchForm.addEventListener('submit', () => {
            closePredictiveSearch();
        });
    }

    if (mobileSearchTrigger && searchSection) {
        mobileSearchTrigger.addEventListener('click', (e) => {
            e.stopPropagation();
            searchSection.classList.toggle('mobile-active');
            if (searchSection.classList.contains('mobile-active') && searchInput) {
                searchInput.focus();
            }
        });
    }

    if (clearSearchBtn && searchInput) {
        clearSearchBtn.addEventListener('click', () => {
            searchInput.value = '';
            closePredictiveSearch();
            searchInput.focus();
        });
    }

    document.addEventListener('click', (e) => {
        if (!e.target.closest('#searchSection')) {
            closePredictiveSearch();
        }
    });

    // 3. Quick Order General Modal Elements
    const quickOrderBtn = document.getElementById('quickOrderBtn');
    const orderModal = document.getElementById('orderModal');
    const modalCloseBtn = document.getElementById('modalCloseBtn');

    function openOrderModal() {
        if (orderModal) {
            orderModal.classList.add('active');
            document.body.style.overflow = 'hidden';
        }
    }

    function closeOrderModal() {
        if (orderModal) {
            orderModal.classList.remove('active');
            document.body.style.overflow = '';
        }
    }

    if (quickOrderBtn) quickOrderBtn.addEventListener('click', openOrderModal);
    if (modalCloseBtn) modalCloseBtn.addEventListener('click', closeOrderModal);
    if (orderModal) {
        orderModal.addEventListener('click', (e) => {
            if (e.target === orderModal) {
                closeOrderModal();
            }
        });
    }

    // 4. Live Dynamic Product Specs Modal & Global Interactivity
    window.openDynamicSpecsModal = async function (cardOrData) {
        const modal = document.getElementById('specsModal') || document.getElementById('specsModalOverlay');
        if (!modal) return;

        let data = {};

        if (cardOrData instanceof HTMLElement) {
            const card = cardOrData;
            data = {
                title: card.getAttribute('data-product-title') || card.querySelector('.phone-title, .showcase-title')?.textContent?.trim() || 'جوال أوكتيل',
                type: card.getAttribute('data-product-type') || card.getAttribute('data-product-vendor') || 'أوكتيل اليمن',
                price: card.getAttribute('data-product-price') || card.querySelector('.price-amount, .price-current')?.textContent?.trim() || '',
                compare: card.getAttribute('data-product-compare') || '',
                url: card.getAttribute('data-product-url') || card.querySelector('a')?.href || '#',
                img: card.getAttribute('data-product-img') || card.querySelector('img')?.src || '',
                desc: card.getAttribute('data-product-desc') || card.querySelector('.phone-subtitle, .showcase-desc')?.textContent?.trim() || '',
                variants: card.getAttribute('data-product-variants') || '',
                wa: card.getAttribute('data-phone-wa') || '967777779564',
                handle: card.getAttribute('data-product-handle') || ''
            };
        } else if (typeof cardOrData === 'object') {
            data = cardOrData;
        }

        // Live AJAX fetch from Shopify API if handle is available and extra details needed
        if (data.handle && !data.desc) {
            try {
                const res = await fetch(`/products/${data.handle}.js`);
                if (res.ok) {
                    const liveProd = await res.json();
                    if (liveProd.title) data.title = liveProd.title;
                    if (liveProd.price) data.price = Math.round(liveProd.price / 100) + ' $';
                    if (liveProd.description) data.desc = liveProd.description;
                    if (liveProd.featured_image) data.img = liveProd.featured_image;
                    if (liveProd.variants && liveProd.variants.length > 0) {
                        data.variants = liveProd.variants.map(v => `${v.title}:${Math.round(v.price / 100)} $`).join('|');
                    }
                }
            } catch (err) {
                console.log('Shopify Live fetch:', err);
            }
        }

        // Populate Modal Elements
        const titleEl = modal.querySelector('#specsModalTitle');
        const typeEl = modal.querySelector('#specsModalType');
        const priceEl = modal.querySelector('#specsModalPrice');
        const compareEl = modal.querySelector('#specsModalCompare');
        const imgEl = modal.querySelector('#specsModalImg');
        const descEl = modal.querySelector('#specsModalDesc');
        const descBlock = modal.querySelector('#specsModalDescBlock');
        const variantsEl = modal.querySelector('#specsModalVariants');
        const variantsBlock = modal.querySelector('#specsModalVariantsBlock');
        const viewBtn = modal.querySelector('#specsViewProductBtn');
        const orderBtn = modal.querySelector('#specsOrderLink, #specsOrderFooterBtn');

        if (titleEl) titleEl.textContent = data.title;
        if (typeEl) typeEl.textContent = data.type;
        if (priceEl) priceEl.textContent = data.price;
        if (imgEl && data.img) {
            imgEl.src = data.img;
            imgEl.alt = data.title;
        }
        if (viewBtn) viewBtn.href = data.url;

        if (compareEl) {
            if (data.compare && data.compare !== data.price) {
                compareEl.textContent = data.compare;
                compareEl.style.display = '';
            } else {
                compareEl.style.display = 'none';
            }
        }

        if (descEl) {
            if (data.desc) {
                let str = data.desc;
                const txt = document.createElement('textarea');
                let iter = 0;
                while ((str.indexOf('&lt;') !== -1 || str.indexOf('&amp;') !== -1) && iter < 5) {
                    txt.innerHTML = str;
                    str = txt.value;
                    iter++;
                }
                str = str.replace(/<\s*"\s*(\/)?\s*([a-z1-6]+)/gi, '<$1$2')
                         .replace(/<"\s*([a-z1-6]+)([^>]*)/gi, '<$1$2')
                         .replace(/<\s*\/\s*([a-z1-6]+)\s*\/?>/gi, '</$1>')
                         .replace(/<\s*\/\s*([a-z1-6]+)\s*\/>/gi, '</$1>')
                         .replace(/<p\s*\/>/gi, '<p></p>');
                str = str.replace(/style\s*=\s*"[^"]*"/gi, '')
                         .replace(/style\s*=\s*'[^']*'/gi, '')
                         .replace(/<(p|div|span|h[1-6])\s*>\s*(&nbsp;|<br\s*\/?>|\s)*\s*<\/\1>/gi, '')
                         .replace(/(<br\s*\/?>\s*){2,}/gi, '<br>');
                descEl.innerHTML = str;
            } else {
                descEl.innerHTML = '';
            }
            if (descBlock) descBlock.style.display = data.desc ? '' : 'none';
        }

        if (variantsEl) {
            if (data.variants) {
                const pairs = data.variants.split('|');
                variantsEl.innerHTML = pairs.map(p => {
                    const [name, priceV] = p.split(':');
                    if (!name) return '';
                    return `<div class="variant-chip">
                        <span class="v-name">${name}</span>
                        ${priceV ? `<span class="v-price">${priceV}</span>` : ''}
                    </div>`;
                }).join('');
                if (variantsBlock) variantsBlock.style.display = pairs.length > 1 ? '' : 'none';
            } else {
                if (variantsBlock) variantsBlock.style.display = 'none';
            }
        }

        if (orderBtn) {
            const msg = encodeURIComponent(`أهلاً، أرغب في الاستفسار عن ${data.title} — الوكيل المعتمد أوكتيل اليمن`);
            const waUrl = `https://wa.me/${data.wa || '967777779564'}?text=${msg}`;
            if (orderBtn.tagName === 'A') {
                orderBtn.href = waUrl;
            } else {
                orderBtn.onclick = () => window.open(waUrl, '_blank');
            }
        }

        modal.classList.add('active', 'is-open');
        document.body.style.overflow = 'hidden';
    };

    window.closeSpecsModal = function () {
        const modal = document.getElementById('specsModal') || document.getElementById('specsModalOverlay');
        if (modal) {
            modal.classList.remove('active', 'is-open');
            document.body.style.overflow = '';
        }
    };

    // Close modal triggers
    const specsModalCloseBtn = document.getElementById('specsModalCloseBtn');
    if (specsModalCloseBtn) specsModalCloseBtn.addEventListener('click', window.closeSpecsModal);

    const specsModal = document.getElementById('specsModal');
    if (specsModal) {
        specsModal.addEventListener('click', (e) => {
            if (e.target === specsModal) window.closeSpecsModal();
        });
    }

    // Global Event Delegation for Product Cards, Specs Buttons, and Quick Order Buttons
    document.addEventListener('click', (e) => {
        const specsBtn = e.target.closest('.btn-specs-details');
        if (specsBtn) {
            e.stopPropagation();
            const card = specsBtn.closest('.phone-card, .showcase-card, [data-product-title]');
            if (card) {
                window.openDynamicSpecsModal(card);
            } else {
                window.openDynamicSpecsModal({
                    title: specsBtn.getAttribute('data-phone-name') || 'جوال أوكتيل',
                    handle: specsBtn.getAttribute('data-phone-handle') || ''
                });
            }
            return;
        }

        const orderBtn = e.target.closest('.card-order-btn, .quick-order-btn');
        if (orderBtn) {
            e.stopPropagation();
            const phoneName = orderBtn.getAttribute('data-phone-name') || 'جوال أوكتيل';
            const phoneWa = orderBtn.getAttribute('data-phone-wa') || '967777779564';
            const encodedMessage = encodeURIComponent(`أهلاً، أرغب في طلب ${phoneName} عبر الوكيل المعتمد في اليمن`);
            window.open(`https://wa.me/${phoneWa}?text=${encodedMessage}`, '_blank');
            return;
        }

        // Handle full product card click navigation
        const card = e.target.closest('.showcase-card, .phone-card');
        if (card) {
            if (e.target.closest('button, input, select, textarea')) return;

            const targetLink = e.target.closest('a');
            if (targetLink && targetLink.getAttribute('href') && targetLink.getAttribute('href') !== '#') {
                return;
            }

            const url = card.getAttribute('data-product-url') ||
                        card.querySelector('a[href]:not([href="#"])')?.getAttribute('href') ||
                        (card.getAttribute('data-product-handle') ? `/products/${card.getAttribute('data-product-handle')}` : null);

            if (url && url !== '#') {
                window.location.href = url;
            }
        }
    });

    // Keyboard ESC key handler for all modals
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeDrawer();
            closeOrderModal();
            window.closeSpecsModal();
            closePredictiveSearch();
            if (searchSection) searchSection.classList.remove('mobile-active');
        }
    });

    // 5. Remove Shopify Theme Dev Preview Bar iframe
    function removeShopifyPreviewBar() {
        const previewBars = document.querySelectorAll('#preview-bar-iframe, #admin-bar-iframe, iframe[name="preview-bar-iframe"], .shopify-preview-bar');
        previewBars.forEach(bar => {
            bar.remove();
        });
        document.documentElement.style.setProperty('padding-bottom', '0px', 'important');
        document.documentElement.style.setProperty('margin-bottom', '0px', 'important');
        document.body.style.setProperty('padding-bottom', '0px', 'important');
        document.body.style.setProperty('margin-bottom', '0px', 'important');
    }

    removeShopifyPreviewBar();
    setTimeout(removeShopifyPreviewBar, 500);
    setTimeout(removeShopifyPreviewBar, 1500);
    setTimeout(removeShopifyPreviewBar, 3000);
});


